import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Section } from './Section';
import { useRosaContext } from '../../context';
import { RosaCategoriesEnum } from '../../types';
import { NextButton, PreviousButton } from '../../styles';
import { Paragraph, Title } from '@/components/Typography';
import { useGetRosaScores } from '../../hooks/useGetRosaScores';
import { useGetRosaCategories } from '../../hooks/useGetRosaCategories';

export function ActionPlan() {
	const { organization_id, company_id, report_id, onNextStep, onPreviousStep } = useRosaContext();

	const formFieldName = ['action_plan'];

	const { data: rosaScores, isLoading: isGettingScores } = useGetRosaScores({
		organization_id,
		company_id,
		report_id
	});

	const { data: categories, isLoading: isGettingCategories } = useGetRosaCategories({
		organization_id,
		company_id
	});

	const isLoading = isGettingScores || isGettingCategories;

	if (isLoading) {
		return <Skeleton active />;
	}

	const sectionsMapper: Record<string, { name: string; score: number; form_name: string[] }> = {
		[RosaCategoriesEnum.CHAIR]: {
			name: 'A',
			score: rosaScores?.score_a ?? 0,
			form_name: [...formFieldName, RosaCategoriesEnum.CHAIR]
		},
		[RosaCategoriesEnum.MONITOR_PHONE]: {
			name: 'B',
			score: rosaScores?.score_b ?? 0,
			form_name: [...formFieldName, RosaCategoriesEnum.MONITOR_PHONE]
		},
		[RosaCategoriesEnum.MOUSE_KEYBOARD]: {
			name: 'C',
			score: rosaScores?.score_c ?? 0,
			form_name: [...formFieldName, RosaCategoriesEnum.MOUSE_KEYBOARD]
		}
	};

	return (
		<Row gutter={[0, 50]}>
			<Col span={24}>
				<Row align="middle">
					<Col xs={12}>
						<Title level={4}>{I18n.get('Action plan')}</Title>
					</Col>
					<Col xs={24}>
						<Paragraph style={{ fontSize: 16, margin: 0 }}>
							{I18n.get('Create actions to address the problems encountered')}
						</Paragraph>
					</Col>
				</Row>
			</Col>
			{categories?.map((category) => {
				const sectionData = sectionsMapper[category.name];
				if (!sectionData) {
					return null;
				}
				return (
					<Col span={24} key={category.id}>
						<Section
							category={category}
							description={category.description}
							name={sectionData.name}
							score={sectionData.score}
							fieldName={sectionData.form_name}
						/>
					</Col>
				);
			})}
			<Col span={24}>
				<Row justify="center" gutter={[30, 0]}>
					<Col>
						<PreviousButton type="ghost" onClick={onPreviousStep}>
							{I18n.get('Back')}
						</PreviousButton>
					</Col>
					<Col>
						<NextButton type="primary" onClick={onNextStep}>
							{I18n.get('Next')}
						</NextButton>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
